import React from "react";

function Contact() {
  return (
    <main id="contact">
      <div className="bg"></div>
      <div className="inner">
        <section className="form">
          <h2>Contact Me</h2>
          <form>
            <div className="row flex align-center wrap">
              <input type="text" placeholder="Your Name" required />
              <input type="email" placeholder="Your Email" required />
            </div>
            <textarea required placeholder="Your Message"></textarea>
            <button className="button button-primary">Send</button>
          </form>
        </section>
        <section className="map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d97209.33679417975!2d-111.95119740803142!3d40.413463409248266!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x874d7fedd81a1b69%3A0xfd6fac81600d61c9!2sLehi%2C%20UT%2C%20USA!5e0!3m2!1sen!2sng!4v1691168328281!5m2!1sen!2sng"
            width="600"
            height="450"
            style={{ border: 0 }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            title="location"
          ></iframe>
        </section>
        <section className="policies">
          <h3 className="big">Cancellation Policy</h3>
          <p>
            You will not be charged if you cancel at least 24 hours before your
            appointment starts. Otherwise, you will be charged 50% of service
            price for late cancellations and 100% for no shows.
          </p>
        </section>
      </div>
    </main>
  );
}

export default Contact;
